import { IconProps } from '@radix-ui/react-icons/dist/types'
import { clsx } from 'clsx'

export const RingBellIcon = ({
  isHighlighted,
  highlightClassName,
  ...props
}: IconProps & {
  highlightClassName?: string
  isHighlighted?: boolean
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    className={clsx('[&>.ring-bell-bubble]:text-dark-control-base')}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.93072 2.813C6.50864 2.813 4.54516 4.77648 4.54516 7.19856V11.5215C4.54516 11.5423 4.54518 11.5636 4.5452 11.5853C4.5458 12.1434 4.54668 12.973 4.16838 13.7143H13.6931C13.3147 12.973 13.3156 12.1434 13.3162 11.5853C13.3163 11.5636 13.3163 11.5423 13.3163 11.5215V7.19856C13.3163 4.77648 11.3528 2.813 8.93072 2.813ZM3.29214 7.19856C3.29214 4.08446 5.81662 1.55999 8.93072 1.55999C12.0448 1.55999 14.5693 4.08446 14.5693 7.19856V11.5215C14.5693 12.5318 14.6105 13.3477 15.476 13.7804C15.7359 13.9103 15.8723 14.2019 15.8055 14.4847C15.7388 14.7675 15.4864 14.9673 15.1958 14.9673H2.66563C2.37507 14.9673 2.12264 14.7675 2.05588 14.4847C1.98913 14.2019 2.12556 13.9103 2.38544 13.7804C3.2509 13.3477 3.29214 12.5318 3.29214 11.5215V7.19856Z"
      fill="currentColor"
    />
    <path
      d="M10.1837 15.907C10.1837 16.599 9.62274 17.16 8.93072 17.16C8.23869 17.16 7.6777 16.599 7.6777 15.907C7.6777 15.2149 8.23869 14.654 8.93072 14.654C9.62274 14.654 10.1837 15.2149 10.1837 15.907Z"
      fill="currentColor"
    />

    <path
      d="M15.5991 4.19999C15.5991 5.85685 14.256 7.19999 12.5991 7.19999C10.9423 7.19999 9.59912 5.85685 9.59912 4.19999C9.59912 2.54314 10.9423 1.19999 12.5991 1.19999C14.256 1.19999 15.5991 2.54314 15.5991 4.19999Z"
      fill="currentColor"
      className={clsx(
        'ring-bell-bubble',
        isHighlighted === false && '!fill-transparent',
        highlightClassName
      )}
    />
  </svg>
)
